import { render, staticRenderFns } from "./clickPricing.vue?vue&type=template&id=22336c6b&scoped=true"
import script from "./clickPricing.vue?vue&type=script&lang=js"
export * from "./clickPricing.vue?vue&type=script&lang=js"
import style0 from "./clickPricing.vue?vue&type=style&index=0&id=22336c6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22336c6b",
  null
  
)

export default component.exports